import { BrowserRouter as Router } from "react-router-dom";
import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { store } from "./state/store";
import { Provider } from "react-redux";
import { loadUser } from "./state/slices/user";
import ThemeProvider from "./theme/ThemeProvider";

function RedirectWrapper() {
  if (window.location.pathname === '/' && !window.location.pathname.startsWith('/pam')) {
    window.location.replace('/pam');
    return null;
  }

  return (
    <Router basename="/pam">
      <App />
    </Router>
  );
}

store.dispatch(loadUser())
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <Provider store={store}>
      <ThemeProvider>
        <RedirectWrapper />
      </ThemeProvider>
    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
